<template>
    <div class="d-flex flex-column text-no-wrap text-uppercase text-center">
        <template v-if="$acl.check('isAuth') && profile">
            <span :class="{'grey--text': $vuetify.theme.dark}">Bonjour {{ profile.firstname }}</span>

            <v-menu offset-y style="z-index: 20;" auto content-class="my-menu">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" class="title" @click="refreshProfile">
                        Mon compte
                    </v-btn>
                </template>
                <v-list :color="isThemeAja ? '#1E3945' : ''" class="text-uppercase text-center text-no-wrap">
                    <v-list-item v-if="$acl.not.check('isUserPremium') && $acl.not.check('isProPremium')">
                        <v-btn color="primary" :to="{name: 'register'}" class="mx-auto">
                            Adhérer
                        </v-btn>
                    </v-list-item>
                    <v-list-item :to="{ name: 'profile' }">
                        <v-list-item-title>Mes coordonnées</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!isAjaYoung" :to="{ name: 'payments' }">
                        <v-list-item-title>Mes paiements</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isUser')" :to="{ name: 'Meetings' }">
                        <v-list-item-title>Mes séances</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isProPremium')" :to="{ name: 'MeetingsPro' }">
                        <v-list-item-title>Mes séances PRO</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isUserPremium')" :to="{ name: 'ProfileSurvey' }">
                        <v-list-item-title>
                            <v-icon class="ml-n4 mr-2" :color="isThemeAja ? ($vuetify.theme.dark ? 'white' : '#294D5B') : ($vuetify.theme.dark ? 'primary' : 'secondary')" size="30">person</v-icon>
                            Questionnaire de PROFIL
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isUserPremium')" :to="{ name: 'SatisfactionSurvey' }">
                        <v-list-item-title>
                            <v-icon class="mr-2" :color="isThemeAja ? ($vuetify.theme.dark ? 'white' : '#294D5B') : ($vuetify.theme.dark ? 'primary' : 'secondary')" size="30">sentiment_satisfied</v-icon>
                            Questionnaire de Satisfaction
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="isThemeAja && $acl.check('isUserPremium')" :to="{ name: 'CogSurvey' }">
                        <v-list-item-title>
                            <v-icon class="ml-n4 mr-2" :color="isThemeAja ? ($vuetify.theme.dark ? 'white' : '#294D5B') : ($vuetify.theme.dark ? 'primary' : 'secondary')" size="30">psychology</v-icon>
                            Questionnaire cognitif
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isUserPremium') && !isThemeAja && profile.oncommence_survey_alert" :to="{ name: 'OncommenceSurvey' }">
                        <v-list-item-title>
                            <v-icon class="ml-n4 mr-2" :color="$vuetify.theme.dark ? 'primary' : 'secondary'" size="30">waving_hand</v-icon>
                            Questionnaire onCOMMENCE
                        </v-list-item-title>
                    </v-list-item>
                    <!-- Hide life quality survey for the moment -->
                    <!-- <v-list-item v-if="isThemeAja && $acl.check('isUserPremium')" :to="{ name: 'LifeQualitySurvey' }">
                        <v-list-item-title>
                            <v-icon class="ml-n4 mr-2" :color="isThemeAja ? ($vuetify.theme.dark ? 'white' : '#294D5B') : ($vuetify.theme.dark ? 'primary' : 'secondary')" size="30">help</v-icon>
                            Questionnaire Qualité de vie
                        </v-list-item-title>
                    </v-list-item> -->
                    <v-list-item v-if="$acl.check('isPro')" :to="{name: 'ProWorkshops'}">
                        <v-list-item-title>Mes ateliers</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isPro')" :to="{name: 'ProUsers'}">
                        <v-list-item-title>Mes adhérents</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$acl.check('isPro')" :to="{name: 'ProLibrary'}">
                        <v-list-item-title>
                            Bibliothèque
                        </v-list-item-title>
                    </v-list-item>
                    <!-- [isPro] Messagerie -->
                    <v-tooltip v-if="$acl.check('isPro')" bottom :disabled="hasActiveMailbox">
                        <template #activator="{ on }">
                            <span v-on="on" style="display: block;">
                                <v-list-item :disabled="!hasActiveMailbox" :to="hasActiveMailbox ? { name: 'Messagerie' } : undefined">
                                    <v-list-item-title :class="{ 'grey--text': !hasActiveMailbox }">
                                        <v-badge
                                            v-if="hasActiveMailbox && unreadCount > 0"
                                            :content="unreadCount > 99 ? '99+' : String(unreadCount)"
                                            color="error"
                                            inline
                                            class="mr-1"
                                        ></v-badge>
                                        <v-icon class="mr-2" size="20" :color="hasActiveMailbox ? '' : 'grey'">mail</v-icon>
                                        Messagerie
                                    </v-list-item-title>
                                </v-list-item>
                            </span>
                        </template>
                        <span>Contactez l'admin pour activer votre messagerie</span>
                    </v-tooltip>
                    <v-list-item v-if="hasLicenceAccess" :to="{name: 'ProLicence'}">
                        <v-list-item-title>
                            Espace Licence
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!isAjaYoung" :to="{name: 'payment-donation'}">
                        <v-list-item-title>Faire un don</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="showResubscribeButton" :to="{name: 'payment-resubscription'}">
                        <v-list-item-title>Réadhérer</v-list-item-title>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click.native="logout" to="#">
                        <v-list-item-title>Se déconnecter</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <router-link :class="{'router-link text-no-underline': true, 'grey--text': $vuetify.theme.dark}" to="" @click.native="logout">Se déconnecter</router-link>
        </template>

        <template v-else>
            <span :class="{'grey--text': $vuetify.theme.dark}">Bonjour, identifiez-vous</span>
            <router-link :class="{'router-link text-no-underline title':true, 'white--text': $vuetify.theme.dark}" :active-class="isThemeAja ? 'aja-green-text ' : 'primary--text'" :to="{name: 'login'}">Connexion</router-link>
            <router-link :class="{'router-link text-no-underline': true, 'grey--text': $vuetify.theme.dark}" :active-class="isThemeAja ? 'aja-green-text ' : 'primary--text'" :to="{name: 'register'}">Créer un compte</router-link>
        </template>
    </div>
</template>
<style scoped>
    .my-menu {
        max-height: 400px !important;
    }
    .aja-green-text {
        color: #4E983C !important;
    }
</style>
<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        // 
    },
    data () {
        return {
            // 
        }
    },
    computed: {
        ...mapGetters(['isThemeAja']),
        profile() {
            return this.$store.getters.getProfile
        },
        unreadCount() {
            return this.$store.getters.getUnreadCount
        },
        isAja() {
            return this.profile.is_aja
        },
        isAjaYoung() {
            return this.isAja && this.profile.aja_role === "aja_young"
        },
        showResubscribeButton() {
            if (!this.$acl.check('isPro') || !this.profile.premium_dates) {
                return false;
            }
            const endDate = this.$moment(this.profile.premium_dates.end).format('YYYY-MM-DD');
            const showAlertDate = this.$moment(endDate).subtract(15, 'days').format('YYYY-MM-DD');
            const today = this.$moment().format('YYYY-MM-DD');
            
            return this.$moment(today).isBetween(showAlertDate, endDate);
        },
        hasLicenceAccess() {
            return this.$acl.check('isProLicence');
        },
        hasActiveMailbox() {
            const alias = this.profile?.mailbox_alias;
            if (!alias) return false;
            return !!alias.validated_at && !alias.is_blocked && !alias.deleted_at;
        }
    },
    mounted() {
        // 
    },
    methods: {
        logout() {
            this.$store.dispatch('authLogout')
                .then(()=>{
                    this.$router.push('/login')
                })
        },
        refreshProfile() {
            this.$store.dispatch('profileRequest');
        }
    }

}
</script>
